import PzSelectDropdown, { OptionProps } from "../../../components/PzSelectDropdown";

interface SelectYearDropdownProps {
    onChange: (year: number) => void;
}
export default function SelectYearDropdown({ onChange }: SelectYearDropdownProps) {
    function getYearOptions(): OptionProps<number>[] {
        const startYear = 2022;
        const currentYear = new Date().getFullYear();
        return Array.from(
            { length: currentYear - startYear + 1 },
            (_, idx) => {
                const year = startYear + idx;
                return {
                    label: year.toString(),
                    value: year,
                    isDefault: year === currentYear,
                };
            }
        );
    }
    return (
        <PzSelectDropdown style={{ width: "150px" }} title="Velg år" options={getYearOptions()} onChanged={onChange} />
    );
}
